import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Image } from 'react-bootstrap';

const Mainfooter = ({
  rootClassName = '',
  termsLink = 'Terms and Conditions',
  privacyLink = 'Privacy Policy',
  cookiesLink = 'Cookies Policy',
  imageSrc = '/rma_big_logo.png',
  imageAlt = 'Company Logo',
  text1 = `Robomec Automation Private Limited,
          B133, Opp Sukrut Company, Near Bharat Petroleum Pump,
          Bhambholi, Chakan, Pune 410501, INDIA`,
}) => {
  return (
    <footer className={`py-4 ${rootClassName}`} style={{ backgroundColor: '#ffffff' }}>
      <Container>
        {/* Divider */}
        <Row>
          <Col>
            <hr className="my-4" />
          </Col>
        </Row>
        {/* Footer Row */}
        <Row className="align-items-center mb-3">
          <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
            <Image src={imageSrc} alt={imageAlt} fluid style={{ maxWidth: '200px' }} />
          </Col>
          <Col md={8} className="text-center text-md-end">
            <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-end gap-3">
              <a href="/privacy-policy" className="text-decoration-none text-dark">
                {privacyLink}
              </a>
              <a href="/cookies-policy" className="text-decoration-none text-dark">
                {cookiesLink}
              </a>
            </div>
          </Col>
        </Row>
        {/* Footer Text */}
        <Row>
          <Col>
            <p className="text-left mb-0 text-muted">
              © 2025 Robomec Automation
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

Mainfooter.propTypes = {
  rootClassName: PropTypes.string,
  termsLink: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  text1: PropTypes.string,
  privacyLink: PropTypes.string,
  cookiesLink: PropTypes.string,
};

export default Mainfooter;
